import { call, put, takeLatest } from "redux-saga/effects";
import * as authApis from "../apis/authApis"
import { FORGOT_PASSWORD, LOGIN, REGISTER, RESET_PASSWORD, UPDATE_ACCOUNT, UPLOAD_IMAGE, VIEW_ACCOUNT } from "../actions/types";
import { USER_DATA_FAILED, USER_DATA_LOADED } from "../actions/returnType";

export function* loginWorker(action) {
    try {
        const res = yield call(authApis.loginApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data?.store });
        } else {
            yield action.onError(res);
            yield put({
                type: USER_DATA_FAILED,
                data: res?.data,
            });
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* registerWorker(action) {
    try {
        const res = yield call(authApis.registerApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);

        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* accountDetailsWorker(action) {
    try {
        const res = yield call(authApis.fetchAccountApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data });
        } else {
            yield action.onError(res);
            yield put({
                type: USER_DATA_FAILED,
                data: res?.data,
            });
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* accountUpdateWorker(action) {
    try {
        const res = yield call(authApis.updateAccountApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data });
        } else {
            yield action.onError(res);
            yield put({
                type: USER_DATA_FAILED,
                data: res?.data,
            });
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadImageWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(authApis.uploadImageApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* forgotPasswordWorker(action) {
    try {
        const res = yield call(authApis.forgotPasswordApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* resetPasswordWorker(action) {
    try {
        const res = yield call(authApis.resetPasswordApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Watcher functions */

export function* loginWorkerWatcher() {
    yield takeLatest(LOGIN, loginWorker);
}

export function* registerWatcher() {
    yield takeLatest(REGISTER, registerWorker);
}

export function* accountDetailsWatcher() {
    yield takeLatest(VIEW_ACCOUNT, accountDetailsWorker);
}

export function* accountUpdateWatcher() {
    yield takeLatest(UPDATE_ACCOUNT, accountUpdateWorker);
}

export function* uploadImageWatcher() {
    yield takeLatest(UPLOAD_IMAGE, uploadImageWorker);
}

export function* forgotPasswordWatcher() {
    yield takeLatest(FORGOT_PASSWORD, forgotPasswordWorker);
}

export function* resetPasswordWatcher() {
    yield takeLatest(RESET_PASSWORD, resetPasswordWorker);
}